import { render, staticRenderFns } from "./newteamAssessment.vue?vue&type=template&id=8fe51da0&scoped=true&"
import script from "./newteamAssessment.vue?vue&type=script&lang=js&"
export * from "./newteamAssessment.vue?vue&type=script&lang=js&"
import style0 from "./newteamAssessment.vue?vue&type=style&index=0&id=8fe51da0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fe51da0",
  null
  
)

export default component.exports